import React from 'react'
import css from './LoadingOverlay.module.css'
import { Spinner } from '@/shared/components/common/Spinner/Spinner'

type LoadingOverlayProps = {
  loading: boolean
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  return (
    <div className={css.overlay}>
      <div className={css.overlay__content}>
        {loading ? (
          <span>Получение данных <Spinner /></span>
        ) : null}
      </div>
    </div>
  )
}

export default LoadingOverlay